import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "wb-body" }
const _hoisted_2 = { class: "wb-tabs" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "wb-rows" }
const _hoisted_6 = {
  key: 0,
  class: "wb-empty"
}
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = { class: "wb-r-date" }
const _hoisted_9 = { class: "wb-r-memo" }
const _hoisted_10 = { class: "wb-r-price" }
const _hoisted_11 = { class: "wb-rows" }
const _hoisted_12 = {
  key: 0,
  class: "wb-empty"
}
const _hoisted_13 = ["disabled", "onClick"]
const _hoisted_14 = { class: "wb-r-date" }
const _hoisted_15 = { class: "wb-r-memo" }
const _hoisted_16 = { class: "wb-r-price" }
const _hoisted_17 = { class: "wb-acc-pane" }
const _hoisted_18 = { class: "wb-acc-head" }
const _hoisted_19 = { class: "wb-acc-head-tools" }
const _hoisted_20 = {
  key: 0,
  class: "wb-acc-hint"
}
const _hoisted_21 = {
  key: 1,
  class: "wb-acc-hint soft"
}
const _hoisted_22 = {
  key: 2,
  class: "wb-acc-list income"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "wb-acc-btn-label" }
const _hoisted_25 = {
  key: 0,
  class: "wb-acc-empty"
}
const _hoisted_26 = ["title", "onClick"]
const _hoisted_27 = { class: "wb-acc-btn-label" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "wb-acc-head" }
const _hoisted_30 = { class: "wb-acc-head-tools" }
const _hoisted_31 = {
  key: 0,
  class: "wb-acc-hint"
}
const _hoisted_32 = {
  key: 1,
  class: "wb-acc-hint soft"
}
const _hoisted_33 = {
  key: 2,
  class: "wb-acc-list expense"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "wb-acc-btn-label" }
const _hoisted_36 = {
  key: 0,
  class: "wb-acc-empty"
}
const _hoisted_37 = ["title", "onClick"]
const _hoisted_38 = { class: "wb-acc-btn-label" }
const _hoisted_39 = { class: "wb-rec-tag" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "wb-acc-head rel" }
const _hoisted_42 = { class: "wb-acc-head-tools" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "wb-acc-hint"
}
const _hoisted_45 = {
  key: 1,
  class: "wb-acc-hint"
}
const _hoisted_46 = {
  key: 2,
  class: "wb-acc-list"
}
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = {
  key: 3,
  class: "wb-acc-hint"
}
const _hoisted_49 = {
  class: "wb-settings",
  role: "dialog",
  "aria-modal": "true",
  "aria-label": "추천 기준"
}
const _hoisted_50 = { class: "wb-settings__head" }
const _hoisted_51 = { class: "wb-settings__head-right" }
const _hoisted_52 = {
  key: 0,
  class: "wb-settings__save-state"
}
const _hoisted_53 = {
  key: 1,
  class: "wb-settings__save-state ok"
}
const _hoisted_54 = {
  key: 2,
  class: "wb-settings__save-state err"
}
const _hoisted_55 = { class: "wb-settings__body" }
const _hoisted_56 = { class: "wb-settings__check" }
const _hoisted_57 = { class: "wb-settings__opts" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "wb-settings__actions" }
const _hoisted_62 = {
  class: "wb-confirm",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_63 = { class: "wb-confirm__head-text" }
const _hoisted_64 = { class: "wb-confirm__kicker" }
const _hoisted_65 = { class: "wb-confirm__body" }
const _hoisted_66 = {
  key: 0,
  class: "wb-confirm__warn"
}
const _hoisted_67 = {
  key: 1,
  class: "wb-confirm__list"
}
const _hoisted_68 = { class: "wb-confirm__actions" }

import { computed, ref, watch } from 'vue';
import { bankbookApi } from '@/services/api';

export interface WorkbenchIncome {
  scode: string;
  sname: string;
  remaining: number;
  totalIncome: number;
  usedExpense: number;
  paired: boolean;
  allowedExpenses: Array<{ scode: string; sname: string }>;
}

export interface WorkbenchItem {
  cb_idx?: number;
  cb_gubun: string;
  cb_scode?: string;
  cb_rel_acc?: string;
  cb_funding?: string;
  cb_memo: string;
  cb_price: number;
  cb_date: string;
  cb_bank_code?: string;
}

type RecommendScope = 'facility' | 'bizGubun' | 'all';

interface RecommendSettings {
  enabled: boolean;
  scope: RecommendScope;
}

type RankedCode = {
  scode: string;
  sname: string;
  reason?: string;
  score: number;
  tag?: '추천' | '짝';
};

const RECOMMEND_STORAGE_KEY = 'caion.bankbook.accountRecommend';

type ConfirmKind = 'income' | 'expense-account' | 'expense-rel';

export default /*@__PURE__*/_defineComponent({
  __name: 'BankbookAdjustWorkbench',
  props: {
    incomes: {},
    pendingItems: {},
    doneItems: {},
    pendingIncomes: { default: () => [] },
    doneIncomes: { default: () => [] },
    selectedScode: {},
    expenseCodes: {},
    incomeCodes: { default: () => [] },
    ledgerItems: { default: () => [] },
    bankNames: {},
    showBank: { type: Boolean },
    loading: { type: Boolean },
    hideList: { type: Boolean, default: false },
    adjustFocus: { default: 'account' },
    isEditable: {},
    memberCode: { default: null },
    bizGubun: { default: null },
    year: { default: null },
    isAdmin: { type: Boolean, default: false }
  },
  emits: ["select-income", "assign-batch", "assign-expense-account", "assign-rel", "assign-funding", "unassign", "assign-income", "unassign-income", "selection-change", "update:listTab", "open-learn", "open-pairs", "open-match"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const defaultRecommendSettings = (): RecommendSettings => ({ enabled: true, scope: 'facility' });

const loadLocalRecommendSettings = (): RecommendSettings => {
  try {
    const raw = localStorage.getItem(RECOMMEND_STORAGE_KEY);
    if (!raw) return defaultRecommendSettings();
    const parsed = JSON.parse(raw) as Partial<RecommendSettings>;
    const scope = parsed.scope === 'bizGubun' || parsed.scope === 'all' ? parsed.scope : 'facility';
    return {
      enabled: parsed.enabled !== false,
      scope,
    };
  } catch {
    return defaultRecommendSettings();
  }
};

const cacheLocalRecommendSettings = (setting: RecommendSettings) => {
  try {
    localStorage.setItem(RECOMMEND_STORAGE_KEY, JSON.stringify(setting));
  } catch {
    // ignore
  }
};

const props = __props;

const emit = __emit;

const listTab = ref<'in' | 'out'>('in');
const selectedIds = ref<number[]>([]);
const selectedIncomeIds = ref<number[]>([]);

const emitSelection = () => {
  emit('selection-change', {
    listTab: listTab.value,
    expenseIds: [...selectedIds.value],
    incomeIds: [...selectedIncomeIds.value],
  });
};
const draftExpense = ref<string | null>(null);
const draftRel = ref<string | null>(null);
const draftFunding = ref<string | null>(null);
const draftIncome = ref<string | null>(null);
/** 조정하기를 누르기 전까지 탭을 옮겨도 유지되는 선택값 */
const expenseListOpen = ref(true);
const incomeListOpen = ref(true);
const searchQuery = ref('');
const incomeSearchQuery = ref('');

const settingsOpen = ref(false);
const recommendSettings = ref<RecommendSettings>(loadLocalRecommendSettings());
const recommendSettingSaveState = ref<'idle' | 'saving' | 'saved' | 'error'>('idle');
const recommendLoading = ref(false);
const recommendMap = ref<Record<string, { score: number; reason: string }>>({});
let recommendTimer: ReturnType<typeof setTimeout> | null = null;
let recommendSeq = 0;
let recommendSaveTimer: ReturnType<typeof setTimeout> | null = null;
let recommendSaveSeq = 0;
let recommendHydratedMember: string | null = null;

const applyRecommendSettings = (setting: RecommendSettings) => {
  recommendSettings.value = {
    enabled: setting.enabled !== false,
    scope: setting.scope === 'bizGubun' || setting.scope === 'all' ? setting.scope : 'facility',
  };
  cacheLocalRecommendSettings(recommendSettings.value);
};

const loadRecommendSettingsFromDb = async () => {
  if (!props.memberCode) return;
  const key = String(props.memberCode);
  try {
    const res = await bankbookApi.getAccountRecommendSetting(props.memberCode);
    const data = res.data?.data;
    if (data && typeof data === 'object') {
      applyRecommendSettings({
        enabled: data.enabled !== false,
        scope: data.scope,
      });
      recommendHydratedMember = key;
      scheduleRecommendRefresh();
      return;
    }
  } catch (error) {
    console.error('계정 추천 설정 조회 오류:', error);
  }
  // DB에 없으면 로컬 캐시 값으로 1회 시드
  if (recommendHydratedMember !== key) {
    try {
      await bankbookApi.saveAccountRecommendSetting(props.memberCode, recommendSettings.value);
      recommendHydratedMember = key;
    } catch (error) {
      console.error('계정 추천 설정 초기 저장 오류:', error);
    }
  }
};

const persistRecommendSettings = () => {
  cacheLocalRecommendSettings(recommendSettings.value);
  scheduleRecommendRefresh();
  if (!props.memberCode) return;

  if (recommendSaveTimer) clearTimeout(recommendSaveTimer);
  recommendSettingSaveState.value = 'saving';
  const seq = ++recommendSaveSeq;
  recommendSaveTimer = setTimeout(async () => {
    try {
      const res = await bankbookApi.saveAccountRecommendSetting(props.memberCode!, {
        enabled: recommendSettings.value.enabled,
        scope: recommendSettings.value.scope,
      });
      const data = res.data?.data;
      if (data && typeof data === 'object') {
        applyRecommendSettings({
          enabled: data.enabled !== false,
          scope: data.scope,
        });
      }
      if (seq === recommendSaveSeq) {
        recommendSettingSaveState.value = 'saved';
        setTimeout(() => {
          if (recommendSettingSaveState.value === 'saved') recommendSettingSaveState.value = 'idle';
        }, 1200);
      }
    } catch (error) {
      console.error('계정 추천 설정 저장 오류:', error);
      if (seq === recommendSaveSeq) recommendSettingSaveState.value = 'error';
    }
  }, 280);
};

const setRecommendScope = (scope: RecommendScope) => {
  recommendSettings.value.scope = scope;
  persistRecommendSettings();
};

watch(
  () => props.memberCode,
  (code) => {
    recommendHydratedMember = null;
    if (code) void loadRecommendSettingsFromDb();
  },
  { immediate: true }
);

const reasonLabel = (source?: string) => {
  if (
    source === 'facility' ||
    source === 'facility_partial' ||
    source === 'exact_match' ||
    source === 'normalized_match'
  ) {
    return source === 'facility_partial' ? '이 시설 적요 유사' : '이 시설 적요 패턴';
  }
  if (
    source === 'otherFacility' ||
    source === 'otherFacility_partial' ||
    source === 'other_exact' ||
    source === 'other_normalized'
  ) {
    return source === 'otherFacility_partial' ? '다른 시설 적요 유사' : '다른 시설 적요 패턴';
  }
  if (source === 'allBizGubun' || source === 'allBizGubun_partial') {
    return source === 'allBizGubun_partial' ? '전체 적요 유사' : '전체 적요 패턴';
  }
  return '적요 패턴';
};

const confirmOpen = ref(false);
const confirmKind = ref<ConfirmKind>('income');
const confirmIsModify = ref(false);
const confirmTitle = ref('');
const confirmMessage = ref('');
const confirmDetails = ref<string[]>([]);
const confirmWarning = ref('');
const pendingIncomeScode = ref<string | null>(null);
const pendingExpenseScode = ref<string | null>(null);
const pendingExpenseRelScode = ref<string | null>(null);

const dateKey = (value?: string) => (value ? String(value).slice(0, 10) : '');
const itemAmount = (item: WorkbenchItem) => Math.abs(Number(item.cb_price) || 0);

const hasScode = (item: WorkbenchItem) => !!(item.cb_scode && String(item.cb_scode).trim());
const hasRel = (item: WorkbenchItem) => !!(item.cb_rel_acc && String(item.cb_rel_acc).trim());

const byDate = (a: WorkbenchItem, b: WorkbenchItem) =>
  dateKey(a.cb_date).localeCompare(dateKey(b.cb_date));

const incomeRows = computed(() =>
  [...props.pendingIncomes, ...props.doneIncomes].sort(byDate)
);

const expenseRows = computed(() =>
  [...props.pendingItems, ...props.doneItems].sort(byDate)
);

const selectedItems = computed(() =>
  expenseRows.value.filter((item) => item.cb_idx && selectedIds.value.includes(item.cb_idx))
);

const selectedIncomeItems = computed(() =>
  incomeRows.value.filter((item) => item.cb_idx && selectedIncomeIds.value.includes(item.cb_idx))
);

const selectedCount = computed(() => selectedItems.value.length);
const selectedIncomeCount = computed(() => selectedIncomeItems.value.length);

const selectedExpenseHasScode = computed(() =>
  selectedItems.value.length > 0 && selectedItems.value.every((item) => hasScode(item))
);

const activeExpenseScode = computed(() => {
  if (props.adjustFocus === 'rel') {
    const scodes = [...new Set(
      selectedItems.value.map((item) => String(item.cb_scode || '').trim()).filter(Boolean)
    )];
    if (scodes.length === 1) return scodes[0];
    if (scodes.length > 1) return null;
  }
  return draftExpense.value;
});

const relAccounts = computed(() => {
  const map = new Map<string, WorkbenchIncome>();
  for (const inc of props.incomes) {
    const scode = String(inc?.scode || '').trim();
    if (!scode) continue;
    map.set(scode, inc);
  }
  for (const code of props.incomeCodes || []) {
    const scode = String(code?.scode || '').trim();
    if (!scode || map.has(scode)) continue;
    map.set(scode, {
      scode,
      sname: code.sname || scode,
      remaining: 0,
      totalIncome: 0,
      usedExpense: 0,
      paired: false,
      allowedExpenses: [],
    });
  }
  return [...map.values()].sort((a, b) => {
    const aHas = (Number(a.remaining) || 0) > 0 ? 1 : 0;
    const bHas = (Number(b.remaining) || 0) > 0 ? 1 : 0;
    if (aHas !== bHas) return bHas - aHas;
    if (aHas && bHas && a.remaining !== b.remaining) return b.remaining - a.remaining;
    return String(a.sname || '').localeCompare(String(b.sname || ''), 'ko');
  });
});

const visibleExpenseCodes = computed(() => {
  const q = searchQuery.value.trim().toLowerCase();
  let base: Array<{ scode: string; sname: string }> = props.expenseCodes;
  // 짝으로 등록된 지출이 코드목록에 없어도 후보에 포함
  if (props.adjustFocus === 'account') {
    const uniq = new Map(base.map((c) => [c.scode, c]));
    for (const inc of props.incomes) {
      for (const exp of inc.allowedExpenses || []) {
        const scode = String(exp.scode || '').trim();
        if (!scode || uniq.has(scode)) continue;
        uniq.set(scode, { scode, sname: exp.sname || scode });
      }
    }
    base = [...uniq.values()];
  } else {
    const paired = relAccounts.value.flatMap((inc) => inc.allowedExpenses || []);
    const uniq = new Map<string, { scode: string; sname: string }>();
    for (const exp of paired) {
      if (!uniq.has(exp.scode)) uniq.set(exp.scode, exp);
    }
    base = uniq.size ? [...uniq.values()] : props.expenseCodes;
  }
  if (!q) return base;
  return base.filter((c) => c.sname.toLowerCase().includes(q) || c.scode.includes(q));
});

const visibleIncomeCodes = computed(() => {
  const q = incomeSearchQuery.value.trim().toLowerCase();
  const list = props.incomeCodes;
  if (!q) return list;
  return list.filter((c) => c.sname.toLowerCase().includes(q) || c.scode.includes(q));
});

const currentExpenseScodes = computed(() =>
  [...new Set(
    selectedItems.value
      .map((item) => String(item.cb_scode || '').trim())
      .filter(Boolean)
  )]
);

const currentIncomeScodes = computed(() =>
  [...new Set(
    selectedIncomeItems.value
      .map((item) => String(item.cb_scode || '').trim())
      .filter(Boolean)
  )]
);

/** 수입→지출 짝: 지출 계정 추천 후보 */
const pairExpenseRecommendMap = computed(() => {
  const map: Record<string, { score: number; reason: string; sname: string }> = {};
  for (const inc of props.incomes) {
    const expenses = inc.allowedExpenses || [];
    if (!expenses.length) continue;
    const remainBoost = Math.min(Math.max(Number(inc.remaining) || 0, 0) / 1_000_000, 25);
    const score = (Number(inc.remaining) > 0 ? 80 : 45) + remainBoost;
    for (const exp of expenses) {
      const scode = String(exp.scode || '').trim();
      if (!scode) continue;
      const reason = `짝 · ${inc.sname}`;
      const prev = map[scode];
      if (!prev || score > prev.score) {
        map[scode] = {
          score,
          reason,
          sname: exp.sname || scode,
        };
      } else if (prev.reason && !prev.reason.includes(inc.sname)) {
        map[scode] = {
          ...prev,
          reason: `${prev.reason} · ${inc.sname}`,
        };
      }
    }
  }
  return map;
});

const hasPairedExpenseRecommend = computed(
  () => Object.keys(pairExpenseRecommendMap.value).length > 0
);

const showExpenseRecommendSection = computed(
  () => recommendSettings.value.enabled || hasPairedExpenseRecommend.value
);

const splitRanked = (
  list: Array<{ scode: string; sname: string }>,
  currentScodes: string[],
  extraMap?: Record<string, { score: number; reason: string }>
) => {
  const currentSet = new Set(currentScodes);
  const current: RankedCode[] = [];
  const recommended: RankedCode[] = [];
  const rest: Array<{ scode: string; sname: string }> = [];

  for (const code of list) {
    if (currentSet.has(code.scode)) {
      current.push({
        scode: code.scode,
        sname: code.sname,
        reason: '현재 적용',
        score: 9999,
      });
      continue;
    }
    const hit = recommendMap.value[code.scode];
    const pair = extraMap?.[code.scode];
    if (hit || pair) {
      const score = (hit?.score || 0) + (pair?.score || 0);
      let reason = hit?.reason || '';
      if (pair?.reason) {
        reason = reason ? `${pair.reason} · ${reason}` : pair.reason;
      }
      recommended.push({
        scode: code.scode,
        sname: code.sname,
        reason: reason || '추천',
        score,
        tag: pair && !hit ? '짝' : '추천',
      });
    } else {
      rest.push(code);
    }
  }

  current.sort((a, b) => a.sname.localeCompare(b.sname, 'ko'));
  recommended.sort((a, b) => b.score - a.score || a.sname.localeCompare(b.sname, 'ko'));
  return { current, recommended, rest };
};

const rankedExpenseCodes = computed(() =>
  splitRanked(
    visibleExpenseCodes.value,
    currentExpenseScodes.value,
    pairExpenseRecommendMap.value
  )
);
const rankedIncomeCodes = computed(() =>
  splitRanked(visibleIncomeCodes.value, currentIncomeScodes.value)
);

const scheduleRecommendRefresh = () => {
  if (recommendTimer) clearTimeout(recommendTimer);
  recommendTimer = setTimeout(() => {
    void refreshRecommendations();
  }, 180);
};

const refreshRecommendations = async () => {
  const seq = ++recommendSeq;
  if (!recommendSettings.value.enabled || !props.memberCode) {
    recommendMap.value = {};
    recommendLoading.value = false;
    return;
  }

  const gubun = listTab.value === 'in' ? 'IN' : 'OUT';
  const items = gubun === 'IN' ? selectedIncomeItems.value : selectedItems.value;
  if (!items.length || props.adjustFocus === 'rel') {
    recommendMap.value = {};
    recommendLoading.value = false;
    return;
  }

  const memoMap = new Map<string, number>();
  for (const item of items) {
    const memo = String(item.cb_memo || '').trim();
    if (!memo) continue;
    memoMap.set(memo, (memoMap.get(memo) || 0) + 1);
  }
  if (!memoMap.size) {
    recommendMap.value = {};
    recommendLoading.value = false;
    return;
  }

  recommendLoading.value = true;
  const scores: Record<string, { score: number; reason: string }> = {};
  try {
    const entries = [...memoMap.entries()].slice(0, 8);
    await Promise.all(entries.map(async ([memo, weight]) => {
      try {
        const res = await bankbookApi.infer(props.memberCode!, {
          memo,
          gubun,
          bizGubun: props.bizGubun || undefined,
          scope: recommendSettings.value.scope,
          year: props.year != null ? String(props.year) : undefined,
        });
        const data = res.data?.data || res.data;
        const scode = data?.scode ? String(data.scode) : '';
        if (!scode) return;
        const count = Number(data?.count) || 1;
        const reason = reasonLabel(data?.source);
        const prev = scores[scode];
        const add = weight * (1 + Math.min(count, 20) / 10);
        if (!prev || add > prev.score) {
          scores[scode] = { score: (prev?.score || 0) + add, reason };
        } else {
          scores[scode] = { score: prev.score + add, reason: prev.reason };
        }
      } catch {
        // ignore per-memo failure
      }
    }));
    if (seq === recommendSeq) recommendMap.value = scores;
  } finally {
    if (seq === recommendSeq) recommendLoading.value = false;
  }
};

const clearFundingIfIdle = () => {
  if (!selectedIds.value.length && !selectedIncomeIds.value.length) {
    draftFunding.value = null;
  }
};

const applyFundingDraft = (items: Array<{ cb_funding?: string }>) => {
  const codes = [...new Set(items.map((item) => String(item.cb_funding || '').trim()).filter(Boolean))];
  draftFunding.value = codes.length === 1 ? codes[0] : null;
};

const syncExpenseDraftFromSelection = () => {
  const picked = expenseRows.value.filter((row) => row.cb_idx && selectedIds.value.includes(row.cb_idx));
  if (!picked.length) {
    draftExpense.value = null;
    draftRel.value = null;
    clearFundingIfIdle();
    expenseListOpen.value = true;
    return;
  }
  const scodes = [...new Set(picked.map((row) => String(row.cb_scode || '').trim()).filter(Boolean))];
  draftExpense.value = scodes.length === 1 ? scodes[0] : null;
  const rels = [...new Set(picked.map((row) => String(row.cb_rel_acc || '').trim()).filter(Boolean))];
  draftRel.value = rels.length === 1 ? rels[0] : null;
  if (listTab.value === 'out') applyFundingDraft(picked);
  expenseListOpen.value = true;
};

const adjustTargets = computed(() =>
  listTab.value === 'in' ? selectedIncomeItems.value : selectedItems.value
);

// draft는 현재 값으로 채워지므로, 「실제로 값이 달라지는지」로 변경 의도를 판정
const expenseDirty = computed(() => {
  const items = selectedItems.value;
  if (!items.length) return false;
  return !!draftExpense.value && items.some(
    (item) => String(item.cb_scode || '').trim() !== draftExpense.value
  );
});
const relDirty = computed(() => {
  const items = selectedItems.value;
  if (!items.length) return false;
  return !!draftRel.value && items.some(
    (item) => String(item.cb_rel_acc || '').trim() !== draftRel.value
  );
});
const incomeDirty = computed(() => {
  const items = selectedIncomeItems.value;
  if (!items.length) return false;
  return !!draftIncome.value && items.some(
    (item) => String(item.cb_scode || '').trim() !== draftIncome.value
  );
});
const fundingDirty = computed(() => {
  const items = adjustTargets.value;
  if (!items.length) return false;
  return !!draftFunding.value && items.some(
    (item) => String(item.cb_funding || '').trim() !== draftFunding.value
  );
});

const expenseAdjustDirty = computed(
  () => expenseDirty.value || relDirty.value || fundingDirty.value
);

const canSubmitExpenseAdjust = computed(() => {
  if (!selectedItems.value.length || !expenseAdjustDirty.value) return false;
  // 자금원천만 실제로 바뀌는 경우: 계정·상대계정 조건 없이 허용
  if (fundingDirty.value && !expenseDirty.value && !relDirty.value) return true;
  const missingRel = selectedItems.value.some((item) => !hasRel(item));
  if (relAccounts.value.length > 0 && missingRel && !draftRel.value) return false;
  if (draftExpense.value && draftRel.value) return true;
  if (draftExpense.value) return true;
  return !!draftRel.value && selectedItems.value.some((item) => hasScode(item));
});

const canSubmitAdjust = computed(() => {
  if (listTab.value === 'in') {
    return selectedIncomeItems.value.length > 0 && (incomeDirty.value || fundingDirty.value);
  }
  return canSubmitExpenseAdjust.value;
});

const pickExpense = (expenseScode: string) => {
  const items = selectedItems.value.slice();
  if (!items.length) return;
  draftExpense.value = expenseScode;
  expenseListOpen.value = true;
  const changed = items.filter((item) => String(item.cb_scode || '').trim() !== expenseScode);
  if (!changed.length) return;
  emit('assign-expense-account', { items: changed, expenseScode });
};

const pickRel = (incomeScode: string) => {
  if (!selectedItems.value.length) return;
  const items = selectedItems.value.filter((item) => hasScode(item));
  if (!items.length) return;
  draftRel.value = incomeScode;
  const changed = items.filter((item) => String(item.cb_rel_acc || '').trim() !== incomeScode);
  if (!changed.length) return;
  emit('assign-rel', { items: changed, incomeScode });
};

const pickFunding = (funding: string) => {
  const items = adjustTargets.value.slice();
  if (!items.length) return;
  draftFunding.value = funding;
  const changed = items.filter((item) => String(item.cb_funding || '').trim() !== funding);
  if (!changed.length) return;
  emit('assign-funding', { items: changed, funding });
};

const resetExpenseDraft = () => {
  selectedIds.value = [];
  draftExpense.value = null;
  draftRel.value = null;
  draftFunding.value = null;
};

const applyExpenseAdjust = () => {
  const items = selectedItems.value.slice();
  if (!items.length || !canSubmitExpenseAdjust.value) return;
  const expenseScode = expenseDirty.value ? draftExpense.value : null;
  const incomeScode = relDirty.value ? draftRel.value : null;
  const funding = fundingDirty.value ? draftFunding.value : null;
  if (expenseScode && incomeScode) {
    emit('assign-batch', { items, expenseScode, incomeScode, funding: funding || undefined });
  } else if (expenseScode) {
    emit('assign-expense-account', { items, expenseScode, funding: funding || undefined });
  } else if (incomeScode) {
    const relItems = items.filter((item) => hasScode(item));
    if (relItems.length) {
      emit('assign-rel', { items: relItems, incomeScode, funding: funding || undefined });
    }
    if (funding) {
      const fundingOnly = items.filter((item) => !hasScode(item));
      if (fundingOnly.length) emit('assign-funding', { items: fundingOnly, funding });
    }
  } else if (funding) {
    emit('assign-funding', { items, funding });
  }
  resetExpenseDraft();
  emitSelection();
  scheduleRecommendRefresh();
};

const applyIncomeAdjust = () => {
  const items = selectedIncomeItems.value.slice();
  if (!items.length || !(incomeDirty.value || fundingDirty.value)) return;
  const incomeScode = incomeDirty.value ? draftIncome.value : null;
  const funding = fundingDirty.value ? draftFunding.value : null;
  if (incomeScode) {
    emit('assign-income', { items, incomeScode, funding: funding || undefined });
  } else if (funding) {
    emit('assign-funding', { items, funding });
  }
  selectedIncomeIds.value = [];
  draftIncome.value = null;
  draftFunding.value = null;
  emitSelection();
  scheduleRecommendRefresh();
};

const applyAdjust = () => {
  if (listTab.value === 'in') {
    applyIncomeAdjust();
    return;
  }
  applyExpenseAdjust();
};

const syncIncomeDraftFromSelection = () => {
  const picked = incomeRows.value.filter((row) => row.cb_idx && selectedIncomeIds.value.includes(row.cb_idx));
  if (!picked.length) {
    draftIncome.value = null;
    clearFundingIfIdle();
    incomeListOpen.value = true;
    return;
  }
  const scodes = [...new Set(picked.map((row) => String(row.cb_scode || '').trim()).filter(Boolean))];
  draftIncome.value = scodes.length === 1 ? scodes[0] : null;
  if (listTab.value === 'in') applyFundingDraft(picked);
  incomeListOpen.value = true;
};

const formatNumber = (n: number | undefined | null) => (Number(n) || 0).toLocaleString();

const formatDate = (value: string | null) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return `${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}`;
};

const expenseName = (scode?: string) => {
  if (!scode) return '없음';
  return props.expenseCodes.find((c) => c.scode === scode)?.sname
    || props.incomes.flatMap((i) => i.allowedExpenses).find((e) => e.scode === scode)?.sname
    || scode;
};

const incomeName = (scode?: string) => {
  if (!scode) return '없음';
  return props.incomes.find((i) => i.scode === scode)?.sname
    || props.incomeCodes.find((i) => i.scode === scode)?.sname
    || scode;
};

const isPicked = (item: WorkbenchItem) => !!item.cb_idx && selectedIds.value.includes(item.cb_idx);
const isIncomePicked = (item: WorkbenchItem) => !!item.cb_idx && selectedIncomeIds.value.includes(item.cb_idx);

const switchTab = (tab: 'in' | 'out') => {
  if (listTab.value !== tab) draftFunding.value = null;
  listTab.value = tab;
  emit('update:listTab', tab);
  emitSelection();
  scheduleRecommendRefresh();
};

const toggleIncomeRow = (item: WorkbenchItem) => {
  if (!item.cb_idx || !props.isEditable(item)) return;
  if (selectedIncomeIds.value.includes(item.cb_idx)) {
    selectedIncomeIds.value = selectedIncomeIds.value.filter((id) => id !== item.cb_idx);
  } else {
    selectedIncomeIds.value = [...selectedIncomeIds.value, item.cb_idx];
  }
  syncIncomeDraftFromSelection();
  emitSelection();
  scheduleRecommendRefresh();
};

const toggleRow = (item: WorkbenchItem) => {
  if (!item.cb_idx || !props.isEditable(item)) return;
  if (selectedIds.value.includes(item.cb_idx)) {
    selectedIds.value = selectedIds.value.filter((id) => id !== item.cb_idx);
  } else {
    selectedIds.value = [...selectedIds.value, item.cb_idx];
  }
  syncExpenseDraftFromSelection();
  emitSelection();
  scheduleRecommendRefresh();
};

const openConfirm = (opts: {
  kind: ConfirmKind;
  isModify: boolean;
  title: string;
  message: string;
  details: string[];
  warning?: string;
}) => {
  confirmKind.value = opts.kind;
  confirmIsModify.value = opts.isModify;
  confirmTitle.value = opts.title;
  confirmMessage.value = opts.message;
  confirmDetails.value = opts.details;
  confirmWarning.value = opts.warning || '';
  confirmOpen.value = true;
};

const cancelConfirm = () => {
  confirmOpen.value = false;
  confirmWarning.value = '';
  pendingIncomeScode.value = null;
  pendingExpenseScode.value = null;
  pendingExpenseRelScode.value = null;
};

const requestExpenseAccountAssign = (expenseScode: string) => {
  const items = selectedItems.value;
  if (!items.length) return;
  const isModify = items.some((item) => hasScode(item));
  pendingExpenseScode.value = expenseScode;
  pendingIncomeScode.value = null;
  pendingExpenseRelScode.value = null;
  openConfirm({
    kind: 'expense-account',
    isModify,
    title: isModify ? '지출 계정을 수정할까요?' : '지출 계정을 지정할까요?',
    message: isModify
      ? '이미 지정된 지출 계정을 바꿉니다. 상대계정은 유지됩니다.'
      : '선택한 지출 항목에 이 계정을 지정합니다.',
    details: [
      `지출계정 · ${expenseName(expenseScode)}`,
      `대상 ${items.length}건 · ${formatNumber(items.reduce((s, i) => s + itemAmount(i), 0))}원`,
    ],
  });
};

const requestRelAssign = (incomeScode: string) => {
  const items = selectedItems.value;
  if (!items.length || !selectedExpenseHasScode.value) return;
  const isModify = items.some((item) => hasRel(item));
  pendingExpenseRelScode.value = incomeScode;
  pendingIncomeScode.value = null;
  pendingExpenseScode.value = null;
  const expLabel = activeExpenseScode.value
    ? expenseName(activeExpenseScode.value)
    : '여러 지출계정';
  const totalAmount = items.reduce((s, i) => s + itemAmount(i), 0);
  const targetIncome = relAccounts.value.find((inc) => inc.scode === incomeScode);
  const remaining = Number(targetIncome?.remaining) || 0;
  let warning = '';
  if (remaining <= 0) {
    warning = `잔액이 없는 수입 계정입니다. 지정하면 해당 계정 잔액이 마이너스로 표시됩니다.`;
  } else if (totalAmount > remaining) {
    warning = `선택한 지출 합계(${formatNumber(totalAmount)}원)가 이 계정의 잔액(${formatNumber(remaining)}원)을 초과합니다.`;
  }
  openConfirm({
    kind: 'expense-rel',
    isModify,
    title: isModify ? '상대계정을 수정할까요?' : '상대계정을 지정할까요?',
    message: isModify
      ? '이미 지정된 상대계정을 바꿉니다.'
      : '선택한 지출 항목에 이 상대계정을 지정합니다.',
    details: [
      `지출계정 · ${expLabel}`,
      `상대계정 · ${incomeName(incomeScode)}`,
      `대상 ${items.length}건 · ${formatNumber(totalAmount)}원`,
    ],
    warning,
  });
};

const doIncomeAssign = (incomeScode: string) => {
  const items = selectedIncomeItems.value;
  if (!items.length) return;
  emit('assign-income', { items, incomeScode });
  selectedIncomeIds.value = [];
  draftIncome.value = null;
  incomeListOpen.value = true;
  emitSelection();
  scheduleRecommendRefresh();
};

const doExpenseAccountAssign = (expenseScode: string) => {
  if (!selectedItems.value.length) return;
  emit('assign-expense-account', {
    items: selectedItems.value,
    expenseScode,
  });
  selectedIds.value = [];
  draftExpense.value = null;
  expenseListOpen.value = true;
  emitSelection();
  scheduleRecommendRefresh();
};

const doRelAssign = (incomeScode: string) => {
  if (!selectedItems.value.length) return;
  emit('assign-rel', {
    items: selectedItems.value,
    incomeScode,
  });
  selectedIds.value = [];
  draftExpense.value = null;
  expenseListOpen.value = true;
  emitSelection();
};

const runConfirm = () => {
  if (confirmKind.value === 'income' && pendingIncomeScode.value) {
    doIncomeAssign(pendingIncomeScode.value);
  } else if (confirmKind.value === 'expense-account' && pendingExpenseScode.value) {
    doExpenseAccountAssign(pendingExpenseScode.value);
  } else if (confirmKind.value === 'expense-rel' && pendingExpenseRelScode.value) {
    doRelAssign(pendingExpenseRelScode.value);
  }
  cancelConfirm();
};

const onPickIncome = (incomeScode: string) => {
  const items = selectedIncomeItems.value.slice();
  if (!items.length) return;
  draftIncome.value = incomeScode;
  incomeListOpen.value = true;
  const changed = items.filter((item) => String(item.cb_scode || '').trim() !== incomeScode);
  if (!changed.length) return;
  emit('assign-income', { items: changed, incomeScode });
};

const onPickExpenseAccountOnly = (expenseScode: string) => {
  if (!selectedItems.value.length) return;
  draftExpense.value = expenseScode;
  expenseListOpen.value = true;
  requestExpenseAccountAssign(expenseScode);
};

const onOpenLearn = () => {
  settingsOpen.value = false;
  emit('open-learn');
};

const onOpenPairs = () => {
  settingsOpen.value = false;
  emit('open-pairs');
};

watch(searchQuery, (q) => {
  if (q.trim()) expenseListOpen.value = true;
});

watch(incomeSearchQuery, (q) => {
  if (q.trim()) incomeListOpen.value = true;
});

watch(draftExpense, (scode) => {
  if (!scode) expenseListOpen.value = true;
});

watch(draftIncome, (scode) => {
  if (!scode) incomeListOpen.value = true;
});

watch(
  () => props.adjustFocus,
  () => scheduleRecommendRefresh()
);

watch(
  () => expenseRows.value.map((item) => item.cb_idx),
  (ids) => {
    const valid = new Set(ids.filter((id): id is number => typeof id === 'number'));
    selectedIds.value = selectedIds.value.filter((id) => valid.has(id));
    emitSelection();
    scheduleRecommendRefresh();
  }
);

watch(
  () => incomeRows.value.map((item) => item.cb_idx),
  (ids) => {
    const valid = new Set(ids.filter((id): id is number => typeof id === 'number'));
    selectedIncomeIds.value = selectedIncomeIds.value.filter((id) => valid.has(id));
    emitSelection();
    scheduleRecommendRefresh();
  }
);

__expose({
  switchTab,
  toggleRow,
  toggleIncomeRow,
  isPicked,
  isIncomePicked,
  listTab,
  selectedIds,
  selectedIncomeIds,
  openSettings: () => {
    settingsOpen.value = true;
  },
  closeSettings: () => {
    settingsOpen.value = false;
  },
  setExpenseSelection: (ids: number[]) => {
    selectedIds.value = [...ids];
    syncExpenseDraftFromSelection();
    emitSelection();
    scheduleRecommendRefresh();
  },
  setIncomeSelection: (ids: number[]) => {
    selectedIncomeIds.value = [...ids];
    syncIncomeDraftFromSelection();
    emitSelection();
    scheduleRecommendRefresh();
  },
  draftExpense,
  draftRel,
  draftFunding,
  canSubmitExpenseAdjust,
  canSubmitAdjust,
  applyExpenseAdjust,
  applyAdjust,
  pickFunding,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["adjust-wb", { 'is-panel-only': __props.hideList }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!__props.hideList)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: _normalizeClass(["wb-list-pane", { 'is-out': listTab.value === 'out' }])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["wb-tab", { on: listTab.value === 'in' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTab('in')))
              }, [
                _cache[13] || (_cache[13] = _createTextVNode(" 수입 ", -1)),
                (__props.pendingIncomes.length)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_3, _toDisplayString(__props.pendingIncomes.length), 1))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["wb-tab", { on: listTab.value === 'out' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (switchTab('out')))
              }, [
                _cache[14] || (_cache[14] = _createTextVNode(" 지출 ", -1)),
                (__props.pendingItems.length)
                  ? (_openBlock(), _createElementBlock("em", _hoisted_4, _toDisplayString(__props.pendingItems.length), 1))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "wb-cols income" }, [
                _createElementVNode("span", null, "일자"),
                _createElementVNode("span", null, "적요"),
                _createElementVNode("span", null, "금액"),
                _createElementVNode("span", { class: "is-in" }, "계정")
              ], -1)),
              (incomeRows.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, "수입 내역이 없습니다"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(incomeRows.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.cb_idx,
                  type: "button",
                  class: _normalizeClass(["wb-row income", {
              picked: isIncomePicked(item),
              closed: !__props.isEditable(item),
            }]),
                  disabled: !__props.isEditable(item),
                  onClick: ($event: any) => (toggleIncomeRow(item))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(formatDate(item.cb_date)), 1),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(item.cb_memo || '-'), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(formatNumber(item.cb_price)), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["wb-r-acc is-in", { miss: !hasScode(item) }])
                  }, _toDisplayString(hasScode(item) ? incomeName(item.cb_scode) : '미지정'), 3)
                ], 10, _hoisted_7))
              }), 128))
            ], 512), [
              [_vShow, listTab.value === 'in']
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "wb-cols expense" }, [
                _createElementVNode("span", null, "일자"),
                _createElementVNode("span", null, "적요"),
                _createElementVNode("span", null, "금액"),
                _createElementVNode("span", { class: "is-out" }, "지출계정"),
                _createElementVNode("span", { class: "is-in" }, "상대계정")
              ], -1)),
              (expenseRows.value.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, "지출 내역이 없습니다"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(expenseRows.value, (item) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: item.cb_idx,
                  type: "button",
                  class: _normalizeClass(["wb-row expense", {
              picked: isPicked(item),
              closed: !__props.isEditable(item),
            }]),
                  disabled: !__props.isEditable(item),
                  onClick: ($event: any) => (toggleRow(item))
                }, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(formatDate(item.cb_date)), 1),
                  _createElementVNode("span", _hoisted_15, _toDisplayString(item.cb_memo || '-'), 1),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(formatNumber(item.cb_price)), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["wb-r-acc is-out", { miss: !hasScode(item) }])
                  }, _toDisplayString(hasScode(item) ? expenseName(item.cb_scode) : '미지정'), 3),
                  _createElementVNode("span", {
                    class: _normalizeClass(["wb-r-acc is-in", { miss: !hasRel(item) }])
                  }, _toDisplayString(hasRel(item) ? incomeName(item.cb_rel_acc) : '미지정'), 3)
                ], 10, _hoisted_13))
              }), 128))
            ], 512), [
              [_vShow, listTab.value === 'out']
            ])
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("aside", _hoisted_17, [
        (listTab.value === 'in' && __props.adjustFocus === 'account')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_18, [
                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "is-in" }, "수입 계정", -1)),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((incomeSearchQuery).value = $event)),
                    type: "text",
                    class: "wb-acc-search",
                    placeholder: "검색"
                  }, null, 512), [
                    [_vModelText, incomeSearchQuery.value]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "wb-gear",
                    "data-tour": "bb-test-recommend-settings",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('open-match', 'account')))
                  }, "자동화 적용")
                ])
              ]),
              (!selectedIncomeCount.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_20, "왼쪽에서 수입 항목을 고르세요"))
                : (recommendLoading.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_21, "예전에 쓴 계정 찾는 중…"))
                  : _createCommentVNode("", true),
              (selectedIncomeCount.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (rankedIncomeCodes.value.current.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _cache[19] || (_cache[19] = _createElementVNode("p", { class: "wb-acc-sec" }, "현재", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedIncomeCodes.value.current, (code) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: `cur-in-${code.scode}`,
                              type: "button",
                              class: _normalizeClass(["wb-acc-btn current", { on: draftIncome.value === code.scode }]),
                              title: "현재 적용된 계정",
                              onClick: ($event: any) => (onPickIncome(code.scode))
                            }, [
                              _createElementVNode("span", _hoisted_24, _toDisplayString(code.sname), 1),
                              _cache[18] || (_cache[18] = _createElementVNode("em", { class: "wb-cur-tag" }, "현재", -1))
                            ], 10, _hoisted_23))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    (recommendSettings.value.enabled)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "wb-acc-sec" }, "추천", -1)),
                          (!recommendLoading.value && !rankedIncomeCodes.value.recommended.length)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_25, "추천 없음"))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedIncomeCodes.value.recommended, (code) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: `rec-in-${code.scode}`,
                              type: "button",
                              class: _normalizeClass(["wb-acc-btn recommend", { on: draftIncome.value === code.scode }]),
                              title: code.reason || '적요 패턴 추천',
                              onClick: ($event: any) => (onPickIncome(code.scode))
                            }, [
                              _createElementVNode("span", _hoisted_27, _toDisplayString(code.sname), 1),
                              _cache[20] || (_cache[20] = _createElementVNode("em", { class: "wb-rec-tag" }, "추천", -1))
                            ], 10, _hoisted_26))
                          }), 128))
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[22] || (_cache[22] = _createElementVNode("p", { class: "wb-acc-sec" }, "전체", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedIncomeCodes.value.rest, (code) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: code.scode,
                        type: "button",
                        class: _normalizeClass(["wb-acc-btn", { on: draftIncome.value === code.scode }]),
                        onClick: ($event: any) => (onPickIncome(code.scode))
                      }, _toDisplayString(code.sname), 11, _hoisted_28))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (listTab.value === 'out' && __props.adjustFocus === 'account')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[23] || (_cache[23] = _createElementVNode("span", { class: "is-out" }, "지출 계정", -1)),
                  _createElementVNode("div", _hoisted_30, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchQuery).value = $event)),
                      type: "text",
                      class: "wb-acc-search",
                      placeholder: "검색"
                    }, null, 512), [
                      [_vModelText, searchQuery.value]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "wb-gear",
                      "data-tour": "bb-test-recommend-settings",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('open-match', 'account')))
                    }, "자동화 적용")
                  ])
                ]),
                (!selectedCount.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_31, "왼쪽에서 지출 항목을 고르세요"))
                  : (recommendLoading.value && recommendSettings.value.enabled)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, "예전에 쓴 계정 찾는 중…"))
                    : _createCommentVNode("", true),
                (selectedCount.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (rankedExpenseCodes.value.current.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "wb-acc-sec" }, "현재", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedExpenseCodes.value.current, (code) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: `cur-out-${code.scode}`,
                                type: "button",
                                class: _normalizeClass(["wb-acc-btn current", { on: draftExpense.value === code.scode }]),
                                title: "현재 적용된 계정",
                                onClick: ($event: any) => (pickExpense(code.scode))
                              }, [
                                _createElementVNode("span", _hoisted_35, _toDisplayString(code.sname), 1),
                                _cache[24] || (_cache[24] = _createElementVNode("em", { class: "wb-cur-tag" }, "현재", -1))
                              ], 10, _hoisted_34))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true),
                      (showExpenseRecommendSection.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _cache[26] || (_cache[26] = _createElementVNode("p", { class: "wb-acc-sec" }, "추천", -1)),
                            (!recommendLoading.value && !rankedExpenseCodes.value.recommended.length)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_36, "추천 없음"))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedExpenseCodes.value.recommended, (code) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: `rec-out-${code.scode}`,
                                type: "button",
                                class: _normalizeClass(["wb-acc-btn recommend", { on: draftExpense.value === code.scode, pair: code.tag === '짝' }]),
                                title: code.reason || '추천',
                                onClick: ($event: any) => (pickExpense(code.scode))
                              }, [
                                _createElementVNode("span", _hoisted_38, _toDisplayString(code.sname), 1),
                                _createElementVNode("em", _hoisted_39, _toDisplayString(code.tag || '추천'), 1)
                              ], 10, _hoisted_37))
                            }), 128))
                          ], 64))
                        : _createCommentVNode("", true),
                      _cache[27] || (_cache[27] = _createElementVNode("p", { class: "wb-acc-sec" }, "전체", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rankedExpenseCodes.value.rest, (exp) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: exp.scode,
                          type: "button",
                          class: _normalizeClass(["wb-acc-btn", { on: draftExpense.value === exp.scode }]),
                          onClick: ($event: any) => (pickExpense(exp.scode))
                        }, _toDisplayString(exp.sname), 11, _hoisted_40))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (listTab.value === 'out' && __props.adjustFocus === 'rel')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_41, [
                    _cache[28] || (_cache[28] = _createElementVNode("span", { class: "is-in" }, "상대계정", -1)),
                    _createElementVNode("div", _hoisted_42, [
                      (selectedCount.value)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_43, "수입 계정 전체"))
                        : _createCommentVNode("", true),
                      _createElementVNode("button", {
                        type: "button",
                        class: "wb-gear",
                        "data-tour": "bb-test-recommend-settings",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('open-match', 'rel')))
                      }, "자동화 적용")
                    ])
                  ]),
                  (!selectedCount.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_44, "왼쪽에서 지출 항목을 고르세요"))
                    : (!relAccounts.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_45, "수입 계정이 없습니다"))
                      : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relAccounts.value, (inc) => {
                            return (_openBlock(), _createElementBlock("button", {
                              key: inc.scode,
                              type: "button",
                              class: _normalizeClass(["wb-acc-btn rel", { on: draftRel.value === inc.scode, flat: !(Number(inc.remaining) > 0) }]),
                              disabled: !selectedCount.value,
                              onClick: ($event: any) => (pickRel(inc.scode))
                            }, [
                              _createElementVNode("span", null, _toDisplayString(inc.sname), 1),
                              _createElementVNode("strong", null, _toDisplayString(formatNumber(inc.remaining)), 1)
                            ], 10, _hoisted_47))
                          }), 128))
                        ]))
                ], 64))
              : (_openBlock(), _createElementBlock("p", _hoisted_48, "이 탭에서는 사용할 수 없습니다"))
      ])
    ]),
    (settingsOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "wb-settings-overlay",
          "data-tour": "bb-test-recommend-panel",
          onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (settingsOpen.value = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _cache[30] || (_cache[30] = _createElementVNode("h3", null, "추천 기준", -1)),
              _createElementVNode("div", _hoisted_51, [
                (recommendSettingSaveState.value === 'saving')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_52, "저장중"))
                  : (recommendSettingSaveState.value === 'saved')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_53, "저장됨"))
                    : (recommendSettingSaveState.value === 'error')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_54, "저장 실패"))
                      : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "wb-settings__close",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (settingsOpen.value = false))
                }, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createTextVNode("mdi-close", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _cache[37] || (_cache[37] = _createElementVNode("p", { class: "wb-settings__lead" }, "계정 탭에 보여줄 추천만 바꿉니다. 통장에 넣는 것은 자동화입니다.", -1)),
              _createElementVNode("label", _hoisted_56, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((recommendSettings.value.enabled) = $event)),
                  type: "checkbox",
                  onChange: persistRecommendSettings
                }, null, 544), [
                  [_vModelCheckbox, recommendSettings.value.enabled]
                ]),
                _cache[31] || (_cache[31] = _createElementVNode("span", null, "계정 제안 사용", -1))
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["wb-settings__field", { dim: !recommendSettings.value.enabled }])
              }, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "wb-settings__lbl" }, "어느 적요를 볼지", -1)),
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["wb-settings__opt", { on: recommendSettings.value.scope === 'facility' }]),
                    disabled: !recommendSettings.value.enabled,
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (setRecommendScope('facility')))
                  }, "이 시설만", 10, _hoisted_58),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["wb-settings__opt", { on: recommendSettings.value.scope === 'bizGubun' }]),
                    disabled: !recommendSettings.value.enabled,
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (setRecommendScope('bizGubun')))
                  }, "같은 사업", 10, _hoisted_59),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["wb-settings__opt", { on: recommendSettings.value.scope === 'all' }]),
                    disabled: !recommendSettings.value.enabled,
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (setRecommendScope('all')))
                  }, "전체", 10, _hoisted_60)
                ])
              ], 2),
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("button", {
                  type: "button",
                  class: "wb-settings__link",
                  "data-tour": "bb-test-patterns",
                  onClick: onOpenLearn
                }, [
                  _createVNode(_component_v_icon, { size: "16" }, {
                    default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createTextVNode("mdi-book-search-outline", -1)
                    ]))]),
                    _: 1
                  }),
                  _cache[34] || (_cache[34] = _createTextVNode(" 기억된 적요 ", -1))
                ]),
                (__props.isAdmin)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "wb-settings__link",
                      "data-tour": "bb-test-pairs",
                      onClick: onOpenPairs
                    }, [
                      _createVNode(_component_v_icon, { size: "16" }, {
                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                          _createTextVNode("mdi-link-variant", -1)
                        ]))]),
                        _: 1
                      }),
                      _cache[36] || (_cache[36] = _createTextVNode(" 수입–지출 연결 ", -1))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (confirmOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "wb-confirm-overlay",
          onClick: _withModifiers(cancelConfirm, ["self"])
        }, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", {
              class: _normalizeClass(["wb-confirm__head", confirmIsModify.value ? 'is-modify' : 'is-new'])
            }, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("p", _hoisted_64, _toDisplayString(confirmIsModify.value ? '계정 수정' : '계정 지정'), 1),
                _createElementVNode("h3", null, _toDisplayString(confirmTitle.value), 1)
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "wb-confirm__close",
                "aria-label": "닫기",
                onClick: cancelConfirm
              }, [
                _createVNode(_component_v_icon, { size: "18" }, {
                  default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-close", -1)
                  ]))]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("div", _hoisted_65, [
              _createElementVNode("p", null, _toDisplayString(confirmMessage.value), 1),
              (confirmWarning.value)
                ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString(confirmWarning.value), 1))
                : _createCommentVNode("", true),
              (confirmDetails.value.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_67, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(confirmDetails.value, (line, idx) => {
                      return (_openBlock(), _createElementBlock("li", { key: idx }, _toDisplayString(line), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("button", {
                type: "button",
                class: "wb-confirm__btn ghost",
                onClick: cancelConfirm
              }, "취소"),
              _createElementVNode("button", {
                type: "button",
                class: "wb-confirm__btn primary",
                onClick: runConfirm
              }, _toDisplayString(confirmIsModify.value ? '수정하기' : '지정하기'), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})